export { default } from './part-cases';
